import { i18n } from "@/plugins/i18n";
import { apiClient } from "@/services/api-client";
import store from "@/store/store";

export const errorHandlingApiResponse = {
  methods: {
    //Gebruik deze methode voor algemene http error afhandeling.
    // Voeg een nieuwe methode toe voor speciefieke afhandeling maar verdeeld over meedere componenten
    // Voor component specifieke afhandeling handel dit in de component zelf af.

    getSnackbarText(statuscode: number) {
      var type = "danger";
      var message = i18n.t("error.server_fout");

      switch (statuscode) {
        case 401:
          message = i18n.t("error.geen_toegang");
          break;
        case 500:
          message = i18n.t("error.server_fout");
          break;
        case 504:
          message = i18n.t("error.server_timed_out");
          break;
        default:
          break;
      }

      store.dispatch("snackbarAdded", {
        text: message,
        type: type
      });

      return message;
    }
  }
};
